import * as THREE from "three";
export default class PolycubeMesh {
    static geometryManager;
    group;
    meshes = [];
    currentPolycube = [];
    material;
    numActiveCubes = 0;
    flyDirection = new THREE.Vector3();
    constructor(polycube) {
        this.material = new THREE.MeshPhongMaterial({ color: polycube.getColor(), shininess: 100, reflectivity: 100 });
        this.group = new THREE.Group();
        this.swapPolycube(polycube);
    }
    static setManager(manager) {
        PolycubeMesh.geometryManager = manager;
    }
    swapPolycube(polycube) {
        if (polycube.getRaw() === this.currentPolycube) {
            return;
        }
        this.numActiveCubes = polycube.size();
        this.meshes = [];
        this.group.clear();
        this.group.position.set(0, 0, 0);
        polycube.forEachCell((val, x, y, z) => {
            if (val) {
                this.addCube(polycube, x, y, z);
            }
        });
        this.currentPolycube = polycube.getRaw();
        this.material.color.set(polycube.getColor());
        this.flyDirection = this.middlePosOfGroup().normalize();
    }
    addCube(refPolycube, x, y, z) {
        const dims = refPolycube.getDims();
        const neighbourProfile = refPolycube.getDirectNeighbourProfile(x, y, z);
        const mesh = new THREE.Mesh(PolycubeMesh.geometryManager.retrieveCubeGeometry(neighbourProfile), this.material);
        mesh.position.set(-((dims[2] - 1) / 2) + z, ((dims[0] - 1) / 2) - x, -((dims[1] - 1) / 2) + y);
        this.meshes.push(mesh);
        this.group.add(mesh);
    }
    center() {
        const mid = this.middlePosOfGroup();
        this.group.children.forEach(child => child.position.sub(mid));
    }
    middlePosOfGroup() {
        return this.group.children.reduce((prev, child) => prev.add(child.position), new THREE.Vector3()).divideScalar(this.group.children.length);
    }
    flyBy(factor) {
        const movementVector = this.flyDirection.clone().multiplyScalar(factor);
        const targetPos = this.group.position.clone().add(movementVector);
        const willMoveBehindStartingPosition = targetPos.clone().sub(this.flyDirection).dot(this.flyDirection) < -1;
        if (!willMoveBehindStartingPosition) {
            const distanceFromOrigin = targetPos.distanceTo(new THREE.Vector3());
            if (distanceFromOrigin >= 0 && distanceFromOrigin < 3) {
                this.group.position.add(movementVector);
            }
        }
        else {
            this.group.position.set(0, 0, 0);
        }
    }
    asObj3D() {
        return this.group;
    }
}
